import { FormatLabelFn } from '@@partner:types:app'

import {
  ORDER_META_STATUS_WAITING_ASSEMBLER,
  ORDER_META_STATUS_ASSEMBLING,
  ORDER_META_STATUS_NEED_CONTACT,
  ORDER_META_STATUS_REPLACED,
  ORDER_META_STATUS_REMOVED,
  ORDER_META_STATUS_ASSEMBLED,
  ORDER_META_STATUS_ADDED_BY_OPERATOR,
  ORDER_META_STATUS_REFUNDED,
  ORDER_META_STATUS_REFUNDED_BEFORE_DELIVERY
} from '../../config/product'

export const formatPositionStatus: FormatLabelFn = (status) => {
  switch (status) {
  case ORDER_META_STATUS_WAITING_ASSEMBLER:
    return { label: 'Ожидает сборщика', color: undefined }
  case ORDER_META_STATUS_ASSEMBLING:
    return { label: 'Собирается', color: 'cyan' }
  case ORDER_META_STATUS_NEED_CONTACT:
    return { label: 'Связаться с клиентом', color: 'yellow' }
  case ORDER_META_STATUS_REPLACED:
    return { label: 'Заменён', color: 'orange' }
  case ORDER_META_STATUS_REMOVED:
    return { label: 'Удалён', color: 'red' }
  case ORDER_META_STATUS_ASSEMBLED:
    return { label: 'Собран', color: 'green' }
  case ORDER_META_STATUS_ADDED_BY_OPERATOR:
    return { label: 'Добавлен оператором', color: undefined }
  case ORDER_META_STATUS_REFUNDED:
    return { label: 'Возврат', color: 'red' }
  case ORDER_META_STATUS_REFUNDED_BEFORE_DELIVERY:
    return { label: 'Возврат', color: 'red' }
  default:
    return { label: 'Неопределённый статус!', color: 'red' }
  }
}
